import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AuthUser {
  username: string
  role: 'admin' | 'viewer'
  full_name: string
}

interface AuthStore {
  token: string | null
  user: AuthUser | null
  login: (token: string, user: AuthUser) => void
  logout: () => void
  isAuthenticated: () => boolean
}

/** Decode JWT payload without verifying signature (client-side expiry check only). */
function jwtExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return (payload.exp ?? 0) * 1000 < Date.now()
  } catch {
    return true
  }
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set, get) => ({
      token: null,
      user: null,

      login: (token, user) => set({ token, user }),

      logout: () => set({ token: null, user: null }),

      isAuthenticated: () => {
        const { token } = get()
        if (!token) return false
        if (jwtExpired(token)) {
          // Auto-clear expired token
          set({ token: null, user: null })
          return false
        }
        return true
      },
    }),
    {
      name: 'atmvision-auth',   // localStorage key
      partialize: (s) => ({ token: s.token, user: s.user }),
    },
  ),
)
